import { makeObservable } from 'mobx';

import { BaseFilters } from './base-filter';
import { ProjectPriority } from '../project';
import { TaskStatus } from '../task';

export class ProjectTasksFilter extends BaseFilters {
  assigneeIds: (string | null | undefined)[];
  status: TaskStatus[];
  priority: ProjectPriority[];
  tagIds: (string | null | undefined)[];

  tokensMapper = {
    status: 'status',
    assigneeIds: 'assignee',
    priority: 'priority',
    tagIds: 'tag',
  };

  propsMapper = {
    status: 'status',
    priority: 'priority',
    assignee: 'assigneeIds',
    tag: 'tagIds',
  };

  constructor() {
    super('tasksFilter');

    this.assigneeIds = [];
    this.status = [];
    this.priority = [];
    this.tagIds = [];

    this.orderedTokens = [];
    this.filtersCount = 0;

    makeObservable(this, {
      assigneeIds: true,
      status: true,
      priority: true,
      tagIds: true,
      orderedTokens: true,
      filtersCount: true,
    });
  }
}
